import ProductsSecondLevel from "../products-second-level/ProductsSecondLevel";

export default function ProductDirectory() {

    return (
        <div>
            <ProductsSecondLevel></ProductsSecondLevel>
        </div>
    )
}